<template>
  <div class="app-container">
    <navigation :title="message.title"></navigation>
    <div class="notice">
      <div class="time" v-html="message.content"></div>
      <div class="clearfloat"></div>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, List, Icon, Checkbox } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox)
export default {
  name: 'openTime',
  components: {navigation, version},
  data () {
    return {
      message: ''
    }
  },
  created () {
    // 详情
    this.getList()
  },
  htmlClear (fullHtml) {
    // 去掉空div
    var newHtml = fullHtml.replace(/<div([\s\S])*?>[\r\n\s]*<\/div>/g, '')
    newHtml = newHtml.replace(/position: fixed;/gi, '')
    return newHtml
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    getList () {
      var params = {
        readerGuideId: this.$route.query.id
      }
      request('post', '/nlc-web/api/readerGuide/info', params).then(res => {
        console.log('详情', res)
        var newHtml = res.data.content
        newHtml = newHtml.replace(/<div[^\>]*\>(\s)*|[&nbsp;]*<\/div>/gi, '')
        newHtml = newHtml.replace(/position: fixed;/gi, '')
        newHtml = newHtml.replace(/width:(\s)*(\d)*px;/gi, '')
        newHtml = newHtml.replace(/height:(\s)*(\d)*px;/gi, '')
        newHtml = newHtml.replace(/width(\s)*=(\s)*\"(\d)*\"(\s)*/gi, '')

        res.data.content = newHtml
        this.message = res.data
      })
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  overflow-y:scroll;
  min-height: calc(100% - .92rem);
  position: absolute;
  top: 0px;
  bottom: 0px;
}
.notice{
  width:6.1rem;
  margin:1.18rem .28rem .2rem .28rem;
  padding:.2rem .42rem .2rem .42rem;
  background:#fff;
  border-radius:8px;
  font-size:.32rem;
  color:#333;
  clear: both;
  height: auto!important;
}
.notice h1{
  width:100%;
  font-size:.36rem;
  text-align:center;
  margin:0;
  padding:0;
  font-family: SourceHanSerifCN-Medium;
}
>>> p{
  font-family: SourceHanSerifCN-Medium;
}
.time{
  line-height:.52rem;
}
.time p{
  margin-top:.4rem;
}
h2,p{
  margin:0;
  padding:0;
}
h2{
  font-weight: bold;
  font-size:.32rem;
}
>>>p{
  word-break: break-all;
  margin:0;
  padding:0
}
.clearfloat{
  clear:both;
  height:0;
  font-size: 1px;
  line-height: 0px;
}
>>>tr td:first-child{
  width:0;
}
>>>tr td{
  width:25.5%;
  text-align:center;
}
>>>table{
  width:100% !important;
}
</style>



// WEBPACK FOOTER //
// src/view/openTime/index.vue